import { Component, OnInit, inject } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import { SplashScreenComponent } from '@app-layout/splash-screen';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [Bind, Toast, RouterOutlet, SplashScreenComponent]
})
export class AppComponent implements OnInit {
  private primengConfig = inject(PrimeNG);

  horizontalMenu: boolean;

  darkMode = false;

  menuColorMode = 'light';

  menuColor = 'layout-menu-light';

  themeColor = 'blue';

  layoutColor = 'blue';

  ripple = true;

  inputStyle = 'outlined';

  ngOnInit() {
    this.horizontalMenu = false;
    this.primengConfig.ripple.set(true);
  }
}
